/**
 * File: image-carousel.js
 *
 * Import and initialize functions for the Testimonial accessibility
 */

export default {
  slider: document.querySelector('.sc_testimonials'),
  init() {
    if (this.slider) {
      this.render();
    }
  },
  render() {
    const slider = document.querySelector('.sc_testimonials');

    const config = {
      subtree: true,
      attributes: true,
      childList: true,
      characterData: true
    };
    const callback = mutations => {
        mutations.forEach(mutation => {
          if (mutation.target.classList.contains('swiper-slide-active')) {
            const slides = slider.querySelectorAll('.slider-slide');
            slides.forEach(slide => {
              if (slide.classList.contains('swiper-slide-active')) {
                slide.removeAttribute('aria-hidden');
              }
              else {
                slide.setAttribute('aria-hidden', 'true');
              }
            });
          }
        });
    }

    const observer = new MutationObserver(callback);
    observer.observe(slider, config);
  },
};